/* ============================================
   GAS STATION CO. — FEED JS
   Filter, Heart, Animations, Infinite Scroll
   ============================================ */

(function () {
  'use strict';

  /* ---------- Filter Pills ---------- */
  function initFilters() {
    var pills = document.querySelectorAll('.pill[data-filter]');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');

        var filter = pill.getAttribute('data-filter');
        var cards = document.querySelectorAll('.feed .card[data-type]');

        cards.forEach(function (card) {
          if (filter === 'alle' || card.getAttribute('data-type') === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  /* ---------- Heart Toggle ---------- */
  function initHearts() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.heart-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('liked');
    });

    /* Prevent more-btn from navigating */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.more-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
    });
  }

  /* ---------- Staggered Entrance Animation ---------- */
  function initAnimations() {
    var cards = document.querySelectorAll('.feed .card:not(.card--cloned)');
    cards.forEach(function (card, i) {
      card.style.animationDelay = Math.min(i * 40, 800) + 'ms';
    });
  }

  /* ---------- Infinite Scroll Loop ---------- */
  function initInfiniteScroll() {
    var feed = document.getElementById('feedGrid');
    var loader = document.getElementById('feedLoader');
    if (!feed || !loader) return;

    /* Capture original cards as HTML source for cloning */
    var originalCards = feed.querySelectorAll('.card:not(.card--cloned)');
    var sourceHTML = [];
    originalCards.forEach(function (card) {
      sourceHTML.push(card.outerHTML);
    });

    if (!sourceHTML.length) return;

    var isLoading = false;
    var batchCount = 0;
    var maxBatches = 20; /* Safety limit: 20 * 24 cards = 480 total max */

    /* Shuffle array helper */
    function shuffle(arr) {
      var shuffled = arr.slice();
      for (var i = shuffled.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = tmp;
      }
      return shuffled;
    }

    /* Load more cards */
    function loadMore() {
      if (isLoading || batchCount >= maxBatches) return;
      isLoading = true;

      /* Simulate brief loading delay for smoothness */
      setTimeout(function () {
        var shuffled = shuffle(sourceHTML);
        /* Take a subset (8-12 cards) for variety */
        var count = 8 + Math.floor(Math.random() * 5);
        var fragment = document.createDocumentFragment();
        var tempDiv = document.createElement('div');

        for (var i = 0; i < count && i < shuffled.length; i++) {
          tempDiv.innerHTML = shuffled[i];
          var clone = tempDiv.firstElementChild;
          clone.classList.add('card--cloned');
          clone.style.animation = 'none';
          fragment.appendChild(clone);
        }

        feed.appendChild(fragment);
        batchCount++;
        isLoading = false;

        /* Hide loader if max reached */
        if (batchCount >= maxBatches) {
          loader.classList.add('feed-loader--hidden');
        }
      }, 300);
    }

    /* IntersectionObserver to detect when loader is near viewport */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      }, {
        rootMargin: '600px 0px' /* Start loading 600px before visible */
      });

      observer.observe(loader);
    } else {
      /* Fallback for older browsers */
      window.addEventListener('scroll', function () {
        var rect = loader.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) {
          loadMore();
        }
      });
    }
  }

  /* ---------- Init ---------- */
  function init() {
    initFilters();
    initHearts();
    initAnimations();
    initInfiniteScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
